export enum Stats {
  Failed = 0,
  Success,
  'In Progress' = 3,
  'Expired' = 4
}
